import { useForm } from '@inertiajs/react';
import { Plus } from 'lucide-react';
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export function CreateTeamDialog({ eventSlug }: { eventSlug: string }) {
  const [open, setOpen] = useState(false);
  const form = useForm({ slug: '', tableNumber: '' });
  const { data, setData, processing, reset } = form;
  const errors = form.errors as unknown as Record<string, string | undefined>;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    form.post(`/admin/${eventSlug}/teams`, {
      preserveScroll: true,
      onSuccess: () => {
        reset();
        setOpen(false);
      },
    });
  };

  return (
    <>
      <Button onClick={() => setOpen(true)}>
        <Plus className="mr-2 h-4 w-4" />
        Create Team
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Create New Team</DialogTitle>
            <DialogDescription>
              Create a new team for the hackathon
            </DialogDescription>
          </DialogHeader>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="grid gap-2">
              <Label htmlFor="team-slug">Team Slug</Label>
              <Input
                id="team-slug"
                placeholder="e.g., team-awesome"
                disabled={processing}
                value={data.slug}
                onChange={(e) => setData('slug', e.target.value)}
              />
              {errors.slug && (
                <p className="text-destructive text-sm">{errors.slug}</p>
              )}
            </div>

            <div className="grid gap-2">
              <Label htmlFor="team-table-number">
                Table Number (Optional)
              </Label>
              <Input
                id="team-table-number"
                placeholder="e.g., 1A"
                disabled={processing}
                value={data.tableNumber}
                onChange={(e) => setData('tableNumber', e.target.value)}
              />
              {errors.tableNumber && (
                <p className="text-destructive text-sm">{errors.tableNumber}</p>
              )}
            </div>

            {errors.base && (
              <div className="rounded-md border border-red-200 bg-red-50 p-4">
                <p className="text-red-600 text-sm">{errors.base}</p>
              </div>
            )}

            <div className="flex items-center justify-end gap-2">
              <Button
                type="button"
                variant="outline"
                onClick={() => setOpen(false)}
                disabled={processing}
              >
                Cancel
              </Button>
              <Button type="submit" disabled={processing}>
                {processing ? 'Creating...' : 'Create Team'}
              </Button>
            </div>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
}
